import type { Tealium } from 'src/types/appState';

import { SELECT_AD_CONTINUE } from '../../constants';

export default (tealium: Tealium) => {
  const {
    autoClassifyCategoryChosen,
    autoClassifyCategorySuggested,
    cajaWorkType,
    cajaPayType,
    jobAdClassification,
    jobAdSubClassification,
    productSetId,
    recommendedSalaryRange,
    roleTitle,
    salaryRangeSelected,
  } = tealium;

  return {
    adProductSetId: productSetId,
    adSalaryRangeRecommended: recommendedSalaryRange,
    adSalaryRangeSelected: salaryRangeSelected,
    jobClassification: jobAdClassification,
    jobClassificationSelectedPosition: autoClassifyCategoryChosen,
    jobClassificationSuggestedCount: autoClassifyCategorySuggested,
    jobSalaryType: cajaPayType,
    jobSubClassification: jobAdSubClassification,
    jobTitle: roleTitle,
    jobWorkType: cajaWorkType,
    linkName: SELECT_AD_CONTINUE,
    objectInteraction: SELECT_AD_CONTINUE,
  };
};
